import { Link } from 'react-router-dom'

function Queue({ pieces, loading, getStatusBadge, formatStatus }) {
  if (loading) {
    return (
      <div className="text-center py-12">
        <div className="text-gray-500">Loading content queue...</div>
      </div>
    )
  }

  const needsReview = pieces.filter(p => ['drafts_ready', 'designs_ready', 'overdue'].includes(p.status))
  const inProgress = pieces.filter(p => ['ingested', 'research_done', 'copy_approved', 'design_approved'].includes(p.status))
  const completed = pieces.filter(p => p.status === 'ready_to_post')

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Content Queue</h1>

      {needsReview.length > 0 && (
        <div className="mb-8">
          <h2 className="text-lg font-semibold mb-3 text-gray-700">Needs Review ({needsReview.length})</h2>
          <div className="bg-white rounded-lg shadow">
            {needsReview.map(piece => (
              <Link
                key={piece.id}
                to={`/review/${piece.id}/${piece.status === 'designs_ready' ? 'design' : 'copy'}`}
                className="block p-4 border-b last:border-b-0 hover:bg-gray-50"
              >
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <div className="font-medium text-gray-900">
                      {piece.content_brief?.substring(0, 80) || 'Untitled'}...
                    </div>
                    <div className="text-sm text-gray-500 mt-1">
                      {piece.content_bucket} {piece.industry && `· ${piece.industry}`}
                    </div>
                    <div className="flex items-center gap-4 mt-2 text-sm">
                      <span className="text-gray-500">
                        Publish: {piece.date || 'TBD'}
                      </span>
                      <span className="text-gray-500">
                        Deadline: {piece.draft_deadline}
                      </span>
                    </div>
                  </div>
                  <span className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusBadge(piece.status)}`}>
                    {formatStatus(piece.status)}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}

      {inProgress.length > 0 && (
        <div className="mb-8">
          <h2 className="text-lg font-semibold mb-3 text-gray-700">In Progress ({inProgress.length})</h2>
          <div className="bg-white rounded-lg shadow">
            {inProgress.map(piece => (
              <div key={piece.id} className="p-4 border-b last:border-b-0">
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <div className="font-medium text-gray-900">
                      {piece.content_brief?.substring(0, 80) || 'Untitled'}...
                    </div>
                    <div className="text-sm text-gray-500 mt-1">
                      {piece.content_bucket} {piece.industry && `· ${piece.industry}`}
                    </div>
                  </div>
                  <span className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusBadge(piece.status)}`}>
                    {formatStatus(piece.status)}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {completed.length > 0 && (
        <div>
          <h2 className="text-lg font-semibold mb-3 text-gray-700">Completed ({completed.length})</h2>
          <div className="bg-white rounded-lg shadow">
            {completed.slice(0, 5).map(piece => (
              <div key={piece.id} className="p-4 border-b last:border-b-0">
                <div className="flex items-center justify-between">
                  <div className="font-medium text-gray-900">
                    {piece.content_brief?.substring(0, 80) || 'Untitled'}...
                  </div>
                  <span className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusBadge(piece.status)}`}>
                    {formatStatus(piece.status)}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default Queue
